const OUTCOME_KEY = "ga_myth_fact_outcome";

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

export function rememberMythFactOutcome(isCorrect) {
  try {
    sessionStorage.setItem(
      OUTCOME_KEY,
      JSON.stringify({
        day: todayKey(),
        correct: isCorrect === true,
      })
    );
  } catch {
    /* ignore quota */
  }
}

/** True only after today's Myth or Fact answer was submitted and it was wrong. */
export function mythFactAnswerWasWrong() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(OUTCOME_KEY) || "null");
    return Boolean(saved && saved.day === todayKey() && saved.correct === false);
  } catch {
    return false;
  }
}
